<template>
  <div id="dialog-groupMessages-mask" class="dialog-groupMessages-mask" v-show="isShowDialog">
    <div class="bgImg-mask" v-show="isShowBgImg">
      <img :src="bgImgSrc" alt="大图" />
      <span class="icon-close" @click="isShowBgImg = false"></span>
    </div>
    <div class="dialog-groupMessages">
      <div class="dialog-groupMessages-header">
        <span class="groupName">{{dialogGroupName}}</span>
        <div class="icon-close" @click="isShowDialog = false"></div>
      </div>
      <div class="dialog-groupMessages-content" ref="dialog_groupMessages_content">
        <loadingInDialog :isShowLoadingIcon="isLoadingContextMsg" :iconStyle="loadingInDialogStyle"></loadingInDialog>
        <ul class="list-groupMessages" ref="listMsg">
          <li class="listItem-groupMessages" v-for="item in groupMessageList" :key="item.id">
            <div class="listItem-groupMessages-title">
              <span class="messageSpeaker" v-html="item.userName+'('+item.userNum+')'"></span>
              <span class="messageTime" v-html="item.time"></span>
            </div>
            <div
              class="listItem-groupMessages-content"
              v-if="item.msgType=='1'||'2'"
              v-html="item.context"
              @click="showBgImg($event)"
            ></div>
            <div class="articleInContext" v-if="item.msgType=='6'">
              <span>{{item.news.title}}</span>
              <p>文章来源：{{item.news.tag}}</p>
              <p>文章描述：{{item.news.desc}}</p>
              <div
                class="articleInContext-footer"
                @click="jumpToArticleUrl(item.news.jumpUrl)"
              >查看文章详情</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //是否显示模态框
      isShowDialog: false,
      //群对话记录的数据
      groupMessageList: [],
      //是否正在载入数据
      isLoadingContextMsg: false,
      //加载上下文动画的位置：'top'顶部，'bottom'底部
      loadingInDialogStyle: "",
      //记录当前<群组上下文>的上下页面数
      contextMsg_front: 1,
      contextMsg_back: 1,
      //<群组上下文>上下页总数
      contextMsg_total_front: 1,
      contextMsg_total_back: 1,
      //是否查看大图
      isShowBgImg: false,
      //上下文中当前查看图片的base64编码
      bgImgSrc: "",
      currentMsgType:null
    };
  },
  props: {
    //当前选中的消息id
    currentMsgId: String,
    //当前显示的群名称
    dialogGroupName: String
  },
  created() {},
  mounted() {
    //给模态框绑定滚动事件
    this.initScroll();
  },
  methods: {
    //初始化模态框
    initDialog() {
      //初始化群记录上下文数据
      this.initContextMsg();
      //获取上下文数据
      this.getContextMsg();
    },
    //初始化群记录上下文数据
    initContextMsg() {
      //清除模态框中数据
      this.groupMessageList = [];
      //还原loading状态
      this.loadingInDialogStyle = "";
      //还原页码记录
      this.contextMsg_front = 1;
      this.contextMsg_back = 1;
      this.contextMsg_total_front = 1;
      this.contextMsg_total_back = 1;
    },
    //获取上下文数据
    getContextMsg(flag) {
      if (this.isLoadingContextMsg) return;
      this.isLoadingContextMsg = true;
      let front = 0;
      let back = 0;
      if (flag === "front") {
        front = this.contextMsg_front;
      } else {
        back = this.contextMsg_back;
      }
      if (this.loadingInDialogStyle == "") {
        //如果是第一次加载
        front = back = 1;
      }
      //请求上下文数据
      this.$ajax({
        method: "get",
        url: "./sentiment/groupMsgData/msgContext",
        params: {
          indexId: this.currentMsgId,
          front,
          back
        }
      })
        .then(res => {
          this.isLoadingContextMsg = false;
          if (res.data.success) {
            //如果data不为空
            if (res.data.data) {
              //新增的数据
              let newGroupMessageList = [];
              //获取上下文的总页码数目
              this.contextMsg_total_front =
                res.data.data.frontPage == undefined
                  ? this.contextMsg_total_front
                  : res.data.data.frontPage;
              this.contextMsg_total_back =
                res.data.data.backPage == undefined
                  ? this.contextMsg_total_back
                  : res.data.data.backPage;
              //获取对话列表数据
              let resData = res.data.data.data;
              resData.forEach(item => {
                let context = "";
                if(item.index_id == this.currentMsgId){
                  this.currentMsgType = item.msgType
                }
                if (item.msgType == "1") {
                  //如果是文本数据
                  context = item.msg;
                } else if (item.msgType == "2") {
                  //如果是图片数据
                  let src = item.msg.replace(/\+/g, "%2B");
                  context = `<img src="data:image/jpg;base64,${src}" class="smImg" style="width:300px"/> <span>(点击查看大图)<span>`;
                }
                let newGroupMessageListItem = {
                  id: item.index_id,
                  userName: item.sendMsgName,
                  userNum: item.senderId,
                  time: item.publishTime,
                  msgType: item.msgType,
                  context
                };
                if (item.msgType == "6") {
                  //如果是文章数据
                  if(!item.msg || item.msg == 'null') return
                  let msg;
                  try{
                    //item.msg 可以呗json转换
                    msg = JSON.parse(item.msg)
                    newGroupMessageListItem.news = JSON.parse(item.msg).news
                  }catch{
                    //不规则字符串 会报错
                    newGroupMessageListItem.msgType = 1;
                    newGroupMessageListItem.context = item.msg
                  }
                }
                newGroupMessageList.push(newGroupMessageListItem);
              });
              if (this.loadingInDialogStyle === "top") {
                //如果是向上下载
                this.groupMessageList = [
                  ...newGroupMessageList,
                  ...this.groupMessageList
                ];
                //手动让滚轮向下移动一段距离，使得用户刷新数据不需要向下拉再向上滚的操作
                this.$refs.dialog_groupMessages_content.scrollTo(0, 10);
              } else if (this.loadingInDialogStyle === "bottom") {
                //如果是向下加载
                this.groupMessageList = [
                  ...this.groupMessageList,
                  ...newGroupMessageList
                ];
              } else {
                //如果是第一次加载
                this.groupMessageList = [...newGroupMessageList];
                //跳转到对话相关位置
                let groupMessageIndex = this.groupMessageList.findIndex(item => {
                  return item.id == this.currentMsgId;
                });
                // console.log(groupMessageIndex)
                // if (groupMessageIndex > 3) {
                  //如果该li上面还有大于3条li，则向下滚动到该条li上面的第4条li的位置，确保当前li居中
                  //由于宏任务微任务的区别 nextTick时图片未渲染 导致定位有偏差
                  setTimeout(() => {
                    let listMsg = this.$refs.listMsg;
                    let wrapperHeight = this.$refs.dialog_groupMessages_content.offsetHeight;
                    let topLi = listMsg.getElementsByTagName("li")[groupMessageIndex];
                    let scrollh;
                    if(this.currentMsgType == 2){
                      scrollh = (topLi.offsetTop - wrapperHeight/4) > 0 ? (topLi.offsetTop - wrapperHeight/4) : topLi.offsetTop
                    }else{
                      scrollh = (topLi.offsetTop - wrapperHeight/2) > 0 ? (topLi.offsetTop - wrapperHeight/2 + 50) : topLi.offsetTop
                    }
                    // let scrollh = 
                    // console.log(this.currentMsgType)
                    this.$refs.dialog_groupMessages_content.scrollTo(0,scrollh);
                  },10)
                // }
              }
              //标红相关的对话
              let groupMessageIndex = this.groupMessageList.findIndex(item => {
                  return item.id == this.currentMsgId;
                });
              if (groupMessageIndex !== -1) {
                this.groupMessageList[groupMessageIndex].userName =
                  "<span style='color:red'>" +
                  this.groupMessageList[groupMessageIndex].userName +
                  "</span>";
                this.groupMessageList[groupMessageIndex].userNum =
                  "<span style='color:red'>" +
                  this.groupMessageList[groupMessageIndex].userNum +
                  "</span>";
                this.groupMessageList[groupMessageIndex].time =
                  "<span style='color:red'>" +
                  this.groupMessageList[groupMessageIndex].time +
                  "</span>";
                this.groupMessageList[groupMessageIndex].context =
                  "<span style='color:red'>" +
                  this.groupMessageList[groupMessageIndex].context +
                  "</span>";
              }
              // console.log(this.groupMessageList);
            }
          } else {
            if (res.data.code === 401) {
              this.toLogin();
            } else {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.isLoadingContextMsg = false;
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //初始化群发言信息对话框滚轮
    initScroll() {
      this.$refs.dialog_groupMessages_content.addEventListener("scroll", e => {
        if (
          e.target.scrollHeight - e.target.scrollTop <=
          e.target.clientHeight
        ) {
          //到底
          if (this.contextMsg_total_back > this.contextMsg_back) {
            this.contextMsg_back++;
            this.loadingInDialogStyle = "bottom";
            this.getContextMsg("back");
          }
        }
        if (e.target.scrollTop == 0) {
          //到顶
          if (this.contextMsg_total_front > this.contextMsg_front) {
            this.contextMsg_front++;
            this.loadingInDialogStyle = "top";
            this.getContextMsg("front");
          }
        }
      });
    },
    //打开模态框
    showDialog() {
      this.isShowDialog = true;
    },
    //点击图片显示大图
    showBgImg(e) {
      if (e.target.nodeName === "IMG") {
        this.bgImgSrc = e.target.src;
        this.isShowBgImg = true;
      }
    },
    //点击文章<查看文章详情>跳转到相关页面
    jumpToArticleUrl(url) {
      if (url) {
        window.open(url);
      } else {
        this.$Message.error("该文章尚未提供跳转链接");
      }
    }
  },
  watch: {
    //一旦来自父组件的msgId发生了变化，才去调用数据查询
    currentMsgId(newVal) {
      this.initDialog();
    }
  }
};
</script>

<style lang="less">
@import "../style/common.less";
#dialog-groupMessages-mask {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  top: 0;
  left: 0;
  z-index: 999;
  .dialog-groupMessages {
    height: 640px;
    width: 500px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-30%, -50%);
    .dialog-groupMessages-header {
      width: 100%;
      height: 50px;
      background-color: #415af6;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      text-align: left;
      padding: 0 24px;
      position: relative;
      .groupName {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 50px;
      }
      .icon-close {
        height: 15.6px;
        width: 15.6px;
        background: url("https://static.rong360.com/upload/png/46/06/46062aa91a3c5b0ccc50af1e8a22ef9e.png");
        .pic;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
        margin-right: 24px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
      }
      .icon-close:hover {
        opacity: 0.8;
      }
    }
    .dialog-groupMessages-content {
      position: relative;
      overflow: auto;
      height: 590px;
      width: 100%;
      background-color: #fff;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      padding: 24px;
      .list-groupMessages {
        .listItem-groupMessages {
          border-bottom: 1px solid #ddd;
          padding: 7px 0;
          .listItem-groupMessages-title {
            overflow: hidden;
            margin-bottom: 5px;
            .messageSpeaker {
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #666666;
              letter-spacing: 0;
              line-height: 22px;
              float: left;
            }
            .messageTime {
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #c8c7cc;
              letter-spacing: 0;
              line-height: 22px;
              float: right;
            }
          }
          .listItem-groupMessages-content {
            text-align: left;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #333333;
            letter-spacing: 0;
            line-height: 24px;
            .smImg {
              cursor: zoom-in;
            }
          }
          .articleInContext {
            width: 350px;
            box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.08);
            border: 1px solid #ddd;
            font-family: PingFangSC-Regular;
            margin: 15px 0 10px 0;
            span {
              height: 50px;
              display: inline-block;
              width: 100%;
              border-bottom: 1px solid #ddd;
              padding-left: 20px;
              line-height: 50px;
              text-align: left;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              font-size: 15px;
              color: #333333;
            }
            p {
              text-align: left;
              padding-left: 20px;
              font-size: 13px;
              color: #555;
              margin-top: 7px;
            }
            .articleInContext-footer {
              margin-top: 10px;
              border-top: 1px solid #eee;
              height: 40px;
              line-height: 40px;
              font-size: 14px;
              color: #333333;
              text-align: left;
              padding-left: 20px;
              position: relative;
              cursor: pointer;
              &:hover {
                opacity: 0.8;
              }
              &::before {
                content: "";
                display: inline-block;
                height: 15px;
                width: 15px;
                position: absolute;
                right: 20px;
                top: 50%;
                transform: translateY(-50%);
                background-image: url("https://static.rong360.com/upload/png/87/7a/877a3299664e4243394aab13142edd2b.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
                background-position: center;
              }
            }
          }
        }
      }
    }
  }
  .bgImg-mask {
    height: 100%;
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 1;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 90%;
    }
    .icon-close {
      height: 25px;
      width: 25px;
      background: url("https://static.rong360.com/upload/png/46/06/46062aa91a3c5b0ccc50af1e8a22ef9e.png");
      .pic;
      position: absolute;
      right: 20%;
      top: 5%;
      transform: translate(0, -50%);
      margin-right: 24px;
      cursor: pointer;
      transition: all 0.2s ease-in-out;
    }
    .icon-close:hover {
      opacity: 0.8;
    }
  }
}
</style>
